import { render, staticRenderFns } from "./MenusPlans.vue?vue&type=template&id=9bf4d3ac&"
import script from "./MenusPlans.vue?vue&type=script&lang=js&"
export * from "./MenusPlans.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports